import {StyleSheet, type CSSProperties} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {border, semanticColor} from "@khanacademy/wonder-blocks-tokens";

import LoadingCard from "./loading-card.tsx";
import QuestionContent from "./question-content.tsx";
import type {BlooketQuestion} from "./types.ts";

interface Props {
    cardWidth: number;
    cardHeight: number;
    rightOffset: number;
    bottomOffset: number;
    activeCard: BlooketQuestion | null;
    setCard: (value: BlooketQuestion) => void;
    animationStyle: CSSProperties;
    delay: number;
}

const ActiveCard: React.FC<Props> = (props) => {
    const delayClass = {
        animationDelay: `${props.delay}s`,
        transitionDelay: `${props.delay}s`,
    };
    return (
        <View
            key="top"
            style={[
                styles.card,
                styles.topCard,
                props.animationStyle,
                delayClass,
                {
                    width: props.cardWidth,
                    height: props.cardHeight,
                    bottom: props.bottomOffset,
                    right: props.rightOffset,
                },
            ]}
        >
            {props.activeCard ? (
                <QuestionContent
                    card={props.activeCard}
                    setCard={props.setCard}
                />
            ) : (
                <LoadingCard
                    cardHeight={props.cardHeight}
                    cardWidth={props.cardWidth}
                />
            )}
        </View>
    );
};

const styles = StyleSheet.create({
    card: {
        position: "absolute",
        display: "block",
        overflow: "hidden",
        borderStyle: "solid",
        borderWidth: border.width.thin,
        borderColor: semanticColor.core.border.neutral.subtle,
        borderRadius: border.radius.radius_040,
        backgroundColor: semanticColor.surface.primary,
    },
    topCard: {
        borderStyle: "solid",
        borderWidth: border.width.thin,
        borderRadius: border.radius.radius_040,
    },
});

export default ActiveCard;
